import {FC, memo} from 'react';

type TProps = {
    fill: string
}

const LikeIcon32Fill: FC<TProps> = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M14.9949 27.1244C15.273 27.3666 15.6298 27.5 16 27.5C16.3696 27.5001 16.7267 27.3668 17.0049 27.1248C18.0577 26.2095 19.0719 25.3499 19.9669 24.5918L19.9673 24.5914C22.5861 22.3723 24.8477 20.4558 26.4215 18.5676C28.1807 16.457 29 14.4556 29 12.2693C29 10.1451 28.2676 8.18532 26.9376 6.75084C25.5917 5.29939 23.7447 4.5 21.7369 4.5C20.2361 4.5 18.8616 4.9718 17.6518 5.90217C17.041 6.37175 16.4878 6.9465 16 7.61688C15.5124 6.9465 14.959 6.37175 14.3484 5.90217C13.1386 4.9718 11.7641 4.5 10.2633 4.5C8.25525 4.5 6.40849 5.29939 5.06258 6.75084C3.73257 8.18532 3 10.1451 3 12.2693C3 14.4556 3.81946 16.4571 5.57872 18.5678C7.15253 20.4559 9.41448 22.3727 12.0339 24.5922L12.0385 24.5961C12.9319 25.3531 13.9445 26.2112 14.9949 27.1244Z" fill="#909090"/>
        </svg>
    );
};

export default memo(LikeIcon32Fill);
import {FC, memo} from 'react';

type TProps = {
    fill: string
}

const LikeIcon32Fill: FC<TProps> = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M14.9949 27.1244C15.273 27.3666 15.6298 27.5 16 27.5C16.3696 27.5001 16.7267 27.3668 17.0049 27.1248C18.0577 26.2095 19.0719 25.3499 19.9669 24.5918L19.9673 24.5914C22.5861 22.3723 24.8477 20.4558 26.4215 18.5676C28.1807 16.457 29 14.4556 29 12.2693C29 10.1451 28.2676 8.18532 26.9376 6.75084C25.5917 5.29939 23.7447 4.5 21.7369 4.5C20.2361 4.5 18.8616 4.9718 17.6518 5.90217C17.041 6.37175 16.4878 6.9465 16 7.61688C15.5124 6.9465 14.959 6.37175 14.3484 5.90217C13.1386 4.9718 11.7641 4.5 10.2633 4.5C8.25525 4.5 6.40849 5.29939 5.06258 6.75084C3.73257 8.18532 3 10.1451 3 12.2693C3 14.4556 3.81946 16.4571 5.57872 18.5678C7.15253 20.4559 9.41448 22.3727 12.0339 24.5922L12.0385 24.5961C12.9319 25.3531 13.9445 26.2112 14.9949 27.1244Z" fill="#909090"/>
        </svg>
    );
};

export default memo(LikeIcon32Fill);
